export enum UserType {
    /** A user type for Rocket.Chat apps. */
    APP = 'app',
    /** The user is a regular user of the system. */
    USER = 'user',
    /** A special user type for bots. */
    BOT = 'bot',
    /** This usually represents a livechat guest. */
    UNKNOWN = 'unknown',
}
